<template>
    <div class="rh-head-wrap" :class="{'light-style': props.lightMode}">
        <div class="bg"></div>
        <div class="content">
            <a href="/" class="logo-link">
                <img
                    v-if="!props.lightMode"
                    class="logo" src="https://static.rhkj.com/renhe_fe/other/274.png">
                <img
                    v-else
                    src="https://static.rhkj.com/renhe_fe/other/414.png"/>
            </a>

            <div class="links">
                <a :href="`${baseHost}/`" class="hrf">首页</a>
                <a :href="`${baseHost}/main/allCourse/`" class="hrf">课程</a>
                <a :href="`${baseHost}/news`" class="hrf">资讯</a>
                <router-link :to="{ name: 'qaMain' }" class="hrf">问答</router-link>
                <a :href="`${baseHost}/web/helpSupport`" class="hrf">帮助与支持</a>
            </div>

            <div class="grow"></div>
            <div class="study-center" v-if="showStudyCenter" @click="goCenter()">学习中心</div>

            <el-dropdown
                v-if="isLogin"
                trigger="click" @command="command" popper-class="user-down-center">
                <div class="right-user">
                    {{ userInfo.nickName || '--' }}
                    <el-icon style="font-size: 12px;">
                        <CaretBottom/>
                    </el-icon>
                </div>
                <template #dropdown>
                    <el-dropdown-menu>
                        <!-- <el-dropdown-item class="down-menu-item">
                          <a :href="`${baseHost}/web/uc/course/play/record/userStudyRecord`" class="down-link">
                            学习记录
                          </a>
                        </el-dropdown-item> -->
                        <el-dropdown-item divided class="down-menu-item">
                            <a @click="goMyInfo" class="down-link">
                                个人资料
                            </a>
                        </el-dropdown-item>
                        <el-dropdown-item divided class="down-menu-item">
                            <router-link
                                to="/realNameAuth"
                                class="down-link">
                                实名认证
                            </router-link>
                        </el-dropdown-item>
                        <el-dropdown-item command="logOut" divided class="down-menu-item">
                            <div>
                                退出
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>

            <div v-else class="login-register">
                <span @click="goLogin">登录</span>
                /
                <span @click="goRegister">注册</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import {useUserInfoStore} from '@/store/modules/userInfo.js'
import {removeToken, getToken} from '@/utils/auth'
import { localStorageClear, sessionStorageClear } from "@/utils/ruoyi.js";

const userInfoStore = useUserInfoStore()
import {quitLogin} from "@/api/login";

const props = defineProps({
    showStudyCenter: {
        type: Boolean,
        default: false
    },
    lightMode: { // 浅色模式？即白色背景的 ------此属性作废，全部只有一种。
        type: Boolean,
        default: false
    }
})
const router = useRouter();

const isLogin = computed(() => {
    return Boolean(getToken())
})

const baseHost = inject('baseHost');

function command(arg) {
    if (arg == 'logOut') {
        quit()
    }
}

function quit() {
    quitLogin()
        .then(res => {
        })
        .catch((err) => {
        })
        .finally(() => {
            console.log('退出登录。。。。。')
            // 1.删除localStorage：适配新首页的nuxt项目(迁移至老网校)
            localStorageClear({
                exclude: ['invoiceV2'],
            });
            sessionStorage.clear()
            removeToken()
            // 2.获取所有cookie，并全部删除
            const cookies = document.cookie.split(";");
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i];
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
            }
            //3.页面跳转
            // if (location.hostname.indexOf('localhost') > -1) { // 本地环境
            //   location.href = '/learning/login';
            // } else {
            //   location.href = 'https://' + location.host + '/learning/login' // 线上转发到对应的网校登录页面
            // }
            router.push({
                path: '/login',
                replace: true
            })
        })
}

const goCenter = () => {
    router.push({
        path: '/studyCenter/courseUser',
    })
}
const goMyInfo = () => {
    router.push({
        name: "myInformation",
    })
}
const {userInfo} = storeToRefs(userInfoStore)

function goRegister() {
    router.push({
        name: "register",
    })
}

function goLogin() {
    router.push({
        name: "login",
    })
}

</script>

<style scoped lang="scss">
.rh-head-wrap {
    position: relative;
    height: 50px;
    padding: 15px 0;
    background: linear-gradient(135deg, #4080ff 0%, #165DFF 100%);

    .content {
        width: 1200px;
        margin: 0 auto;
        height: 100%;
        display: flex;
        align-items: center;

        .logo-link {
            display: block;
            margin-right: 100px;
            height: 50px;

            .logo {
                width: auto;
                height: 50px;
            }
        }


        .links {
            display: flex;
            align-items: center;

            .hrf {
                line-height: 20px;
                font-size: 16px;
                color: #FFFFFF;
                padding: 15px;

                &:hover {
                    // background-color: #383d4e;
                    color: #fff;
                }
            }
        }

        .grow {
            flex-grow: 1;
        }

        .study-center {
            color: #fff;
            cursor: pointer;
            line-height: 20px;
            padding: 15px;

            &:hover {
                background-color: #383d4e;
            }
        }

        .right-user {
            color: #999;
            font-size: 18px;
            line-height: 20px;
            font-weight: normal;
            margin-right: 15px;
            padding: 7px 10px;
            cursor: pointer;
            position: relative;
             color: #fff;
            &:hover {
                color: #fff;
            }
        }

        .login-register {
            font-size: 16px;
            color: #FFFFFF;

            > span {
                cursor: pointer;

                &:hover {
                    color: #c5d4f8;
                }
            }
        }
    }

    &.light-style { // 浅色模式样式
        background-color: #FFFFFF;
        padding: 5px 0;

        .links .hrf {
            color: #444;

            &:hover {
                background-color: unset;
                color: #3074E6;
            }
        }

        .right-user {
            &:hover {
                background-color: unset;
                color: #3074E6;
            }
        }

        .login-register {
            color: #444;

            > span {

                &:hover {
                    color: #3074E6;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.user-down-center {
    .down-menu-item {
        padding-left: 25px;
        padding-right: 25px;

        .down-link {
            color: inherit;
        }
    }
}
</style>
